import Vue from 'vue';

const state = {
  user: null,
  logged: !!window.localStorage.getItem('_token'),
  mensajes: [],
  recorridoActivo: false, // true mientras el recorrido guiado está en pantalla
};

const actions = {
  login: ({commit}, userInput) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('login', {user: userInput})
        .then(user => {
            window.localStorage.setItem('_token', user.body.token);
            let now = new Date()
            let timestamp = now.getTime();
            var object = {start: timestamp, keep: userInput.mantener_sesion, end: null};
            if (userInput.mantener_sesion) {
              now.setDate(now.getDate() + 15);
            } else {
              now.setMinutes(now.getMinutes() + 10);
            }
            object.end = now.getTime();
            window.localStorage.setItem('_token_timestamp', JSON.stringify(object));
            commit('setUser');
            resolve(user);
        })
        .catch(error => {
          commit('setError', error, { root: true });
          reject(error);
        })
        .finally(() => {
          commit('stopProcessing', null, { root: true });
        })
    })
  },
  profile: ({commit}, userInput) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('profile', {user: userInput})
        .then(user => {
            window.localStorage.setItem('_token', user.body.token);
            commit('setUser');
            resolve(user);
        })
        .catch(error => {
          commit('setError', error, { root: true });
          reject(error);
        })
        .finally(() => {
          commit('stopProcessing', null, { root: true });
        })
    })
  },

  // Marca como visto el recorrido de novedades (show_new_updates = 0)
  actualizarShowNewUpdates: ({commit}, value = 0) => {
    // Se oculta de inmediato en el store para que no se repita mientras dura la sesión
    commit('setShowNewUpdates', value);
    // El token (JWT) sigue trayendo show_new_updates=1 hasta el próximo login:
    // se guarda el token visto para no repetir el recorrido al recargar la página
    window.localStorage.setItem('_new_updates_seen', window.localStorage.getItem('_token'));
    return new Promise((resolve, reject) => {
      Vue.http.post('show-new-updates', {show_new_updates: value})
        .then(response => {
          // Si el backend devuelve un token actualizado, se conserva para que no reaparezca al recargar
          if (response.body && response.body.token) {
            window.localStorage.setItem('_token', response.body.token);
            commit('setUser');
          }
          resolve(response);
        })
        .catch(error => {
          commit('setError', error, { root: true });
          reject(error);
        })
    })
  },

  verificarMensajes:({commit,dispatch}) => {
    //commit('startProcessing', null, { root: true });
    
      Vue.http.post('verificar_mensajes').then(
        response =>{
          // mantener_sesion
          // let object = JSON.parse(window.localStorage.getItem('_token_timestamp'));
          // let cerrar_sesion = true;
          // if (object) {
          //   let logoutEnd = object.end,
          //   now = new Date().getTime();
          //   if (logoutEnd > now) {
          //     cerrar_sesion = false;
          //   }
          // }
          // if (cerrar_sesion) {
          //   commit("setError", 'Verificación de identidad. Por favor cierre la aplicación e intente nuevamente.', { root:true })
          //   dispatch('logout')
          // }
          
          commit('setMensajes',response.data);
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
    
      }).finally(()=>{
        //commit('stopProcessing', null, { root: true });
      })
  },

  logout: ({commit}) => {
    window.localStorage.removeItem('_token');
    window.localStorage.removeItem('_token_timestamp');
    window.localStorage.removeItem('_new_updates_seen');
    // Las encuestas pendientes son de la sesión que se cierra
    commit('encuestaSatisfaccion/reset', null, { root: true });
    commit('setUser');
    commit('setMensajes',[]);
  }

  // banners publicitario


};

const getters = {
  // Recorrido de novedades pendiente (show_new_updates en 1 o true)
  recorridoPendiente: (state) => {
    const data = state.user && state.user.data;
    return !!data && (data.show_new_updates === true || Number(data.show_new_updates) === 1);
  },
};

const mutations = {
  //establecemos el user a través del token jwt
  setUser: (state) => {
    if(window.localStorage.getItem('_token')) {
      const token = window.localStorage.getItem('_token');
      const jwtDecode = require('jwt-decode');
      const user = jwtDecode(token);
      // Mismo token con el que ya se vio el recorrido: no volver a mostrarlo
      if (user.data && window.localStorage.getItem('_new_updates_seen') === token) {
        user.data.show_new_updates = 0;
      }
      state.user = user;
      state.logged = true;
    } else {
      state.logged = false;
      state.user = null;

    }
  },
  setRecorridoActivo: (state, value) => {
    state.recorridoActivo = value;
  },
  setShowNewUpdates: (state, value) => {
    if (state.user && state.user.data) {
      state.user = {...state.user, data: {...state.user.data, show_new_updates: value}};
    }
  },
  //establecemos el estado del usuario
  setLogged: (state, logged) => {
    state.logged = logged;
  },

  setMensajes: (state, mensajes) => {
    state.mensajes = mensajes;
  },

  addMensaje: (state, { html, variant, autoDismiss = true, dismissTime = 3000 }) => {
    let now = new Date()
    let timestamp = now.getTime();
    // Agregar un ID único basado en timestamp para rastreo
    const mensajeConId = {
      html,
      variant,
      autoDismiss,
      dismissTime,
      _id: `${timestamp}-${Math.random().toString(36).substr(2, 9)}` // ID único string
    };
    state.mensajes.push(mensajeConId);
  },

  removeMensaje: (state, index) => {
    state.mensajes.splice(index, 1);
  },

};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
